import { AnalyticEventCategory, AnalyticEventType } from '../../../../shared/entity_datas/EntityDatas.ts';
import { CA } from './Analytics.ts';
export function sendPurchaseSessionStartedAnalytic(product) {
    const eventData = {
        type: AnalyticEventType.PurchaseSessionStarted,
        category: AnalyticEventCategory.Store,
        stringValue: product.method,
        dimensions: {
            storeProductType: product.storeProductType,
            productType: product.productType
        }
    };
    void CA.sendAnalyticEvent(eventData);
}
export function sendDoubleTapPaymentAbandonedAnalytic(product) {
    const eventData = {
        type: AnalyticEventType.DoubleTapPaymentAbandoned,
        category: AnalyticEventCategory.Store,
        dimensions: {
            storeProductType: product.storeProductType,
            productType: product.productType
        }
    };
    void CA.sendAnalyticEvent(eventData);
}
